import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type ILegalEntityRepository } from '@webapp/platform/legal-entities/business-logic/interfaces/ILegalEntityRepository'
import { type LegalEntityConstructor } from '@webapp/platform/legal-entities/entities/LegalEntity'
import { mapLegalEntityApiModel } from '../../mappers/mapLegalEntityApiModel'
import { type GetLegalEntityListResponse } from '../../types/GetLegalEntityListResponse'

interface Dependency {
  httpClient: IHttpClient
}

export class LegalEntityRepository implements ILegalEntityRepository {
  constructor(private readonly deps: Dependency) {}

  async list(): Promise<LegalEntityConstructor[]> {
    try {
      const res = await this.deps.httpClient.get<GetLegalEntityListResponse>(
        '/api/v3/legal-entities/',
        // `page_size=all` is a Procurify pagination escape hatch (see
        // apiv2/pagination.py:75) — backend disables paging and returns the
        // whole queryset. We rely on this because tab counts + search +
        // pagination are computed client-side off the full list.
        { params: { page_size: 'all' } }
      )

      // The v3 paginator (apiv2/pagination.py:113-119) always wraps list
      // responses as `{ data: [...], pagination: {...} }`, even when the
      // queryset is empty — so `res.data.data` is safe to access. Non-2xx
      // responses throw at the httpClient layer above and never reach here.
      return res.data.data.map(mapLegalEntityApiModel)
    } catch (err) {
      throw throwRepoErrorFromApiV3Error(err)
    }
  }
}
